import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import copy from 'copy-to-clipboard';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import Input from 'components/base/Input';

export const CopyTextWithLabel = ({
  text,
  preview = text,
  label,
  width = '25rem'
}) => {
  return (
    <Flex items='center'>
      {label && (
        <Text
          size='medium'
          color='shuttleGray'
          mr='0.5rem'
          width='6rem'
          align='end'
        >
          {label}
        </Text>
      )}
      <CopiableTextArea
        text={text}
        btnStyle={{ borderRadius: '0 0.3rem 0.3rem 0' }}
      >
        <Input
          width={width}
          disabled
          value={preview}
          style={{
            height: '2.65rem',
            backgroundColor: 'white',
            borderRadius: '0.3rem 0 0 0.3rem',
            'border-right-color': 'transparent'
          }}
        />
      </CopiableTextArea>
    </Flex>
  );
};
class CopiableTextArea extends Component {
  onClick(text) {
    const { onCopy } = this.props;
    copy(text);
    if (onCopy) {
      onCopy();
    }
  }

  render() {
    const {
      text,
      description = '',
      buttonText = 'Copy',
      disableCopy = false,
      children
    } = this.props;

    return (
      <Flex
        justify='space-between'
        content='flex-start'
        items='flex-start'
        direction='column'
      >
        {description && (
          <Text size='small' color='gray' pb='0.1rem' pl='0.2rem'>
            {description}
          </Text>
        )}
        <Flex items='flex-end'>
          <>{children}</>
          <Button
            variant='outlined'
            onClick={() => this.onClick(text)}
            disabled={disableCopy}
            {...(this.props.btnStyle ? { style: this.props.btnStyle } : {})}
          >
            {buttonText}
          </Button>
        </Flex>
      </Flex>
    );
  }
}

CopiableTextArea.propTypes = {
  text: PropTypes.string.isRequired,
  description: PropTypes.string,
  buttonText: PropTypes.string,
  disableCopy: PropTypes.bool,
  onCopy: PropTypes.func
};
